module.exports = __webpack_public_path__ + "img/armor.698c1123.png";